export const GadgetAccessories: React.FC<React.SVGAttributes<{}>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15.553"
      height="40"
      viewBox="0 0 15.553 40"
      {...props}
    >
      <g transform="translate(-331.437 -107.077)">
        <g transform="translate(333.404 107.077)">
          <g>
            <g>
              <g>
                <g>
                  <path
                    id="Path_17439"
                    data-name="Path 17439"
                    d="M343.019,118.195H332.938a.767.767,0,0,1-.77-.767v-8.9a1.453,1.453,0,0,1,1.451-1.451h8.72a1.453,1.453,0,0,1,1.451,1.451v8.9A.767.767,0,0,1,343.019,118.195Zm-9.312-1.537h8.542v-8.041h-8.542Zm8.631-8.041h0Z"
                    transform="translate(-332.168 -107.077)"
                    fill="currentColor"
                  />
                </g>
              </g>
            </g>
          </g>
          <g transform="translate(3.326 3.369)">
            <g>
              <g>
                <g>
                  <g>
                    <g>
                      <path
                        id="Path_17440"
                        data-name="Path 17440"
                        d="M334.174,111.346a.77.77,0,0,1-.77-.77V109.1a.77.77,0,0,1,1.539,0v1.478A.77.77,0,0,1,334.174,111.346Z"
                        transform="translate(-333.404 -108.329)"
                        fill="currentColor"
                      />
                    </g>
                  </g>
                </g>
              </g>
            </g>
            <g transform="translate(3.426)">
              <g>
                <g>
                  <g>
                    <path
                      id="Path_17441"
                      data-name="Path 17441"
                      d="M335.447,111.346a.77.77,0,0,1-.77-.77V109.1a.77.77,0,1,1,1.539,0v1.478A.77.77,0,0,1,335.447,111.346Z"
                      transform="translate(-334.677 -108.329)"
                      fill="currentColor"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
        <g transform="translate(331.437 116.658)">
          <g>
            <g>
              <g>
                <path
                  id="Path_17442"
                  data-name="Path 17442"
                  d="M341.927,141.056a.769.769,0,0,1-.77-.77v-11a.769.769,0,0,1,.77-.77h.926l2.6-7.74v-7.832a.771.771,0,0,0-.77-.77H333.746a.771.771,0,0,0-.77.77v7.832l2.6,7.74h.923a.77.77,0,0,1,.77.77v11a.768.768,0,1,1-1.537,0V130.054h-.71a.77.77,0,0,1-.729-.525l-2.815-8.383a.766.766,0,0,1-.04-.245v-7.958a2.31,2.31,0,0,1,2.309-2.306h10.937a2.307,2.307,0,0,1,2.306,2.306V120.9a.766.766,0,0,1-.04.245l-2.815,8.383a.77.77,0,0,1-.727.525H342.7v10.232A.77.77,0,0,1,341.927,141.056Z"
                  transform="translate(-331.437 -110.637)"
                  fill="currentColor"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};
